import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';
const Ctx = createContext();
export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [company, setCompany] = useState(null);
  const [token,   setToken]   = useState(localStorage.getItem('co_token'));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`)
        .then(r => { setUser(r.data.user); })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else setLoading(false);
  }, [token]);
  const login = async (phone, password) => {
    const r = await axios.post(`${API}/auth/login`, { phone, password });
    if (!['company_admin','super_admin'].includes(r.data.user.role))
      throw new Error('هذا الحساب ليس حساب شركة');
    localStorage.setItem('co_token', r.data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${r.data.token}`;
    setToken(r.data.token);
    setUser(r.data.user);
    setCompany(r.data.companyProfile);
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem('co_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null); setUser(null); setCompany(null);
  };
  return <Ctx.Provider value={{ user, company, token, loading, login, logout }}>{children}</Ctx.Provider>;
};
export const useAuth = () => useContext(Ctx);
